import BaseConfig from '@/config/base.js'

export function pxToRem(px) {
  const n = Number(px)
  return `${Math.round((n / BaseConfig.remRootValue) * 1e5) / 1e5}rem`
}

export default pxToRem
